import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Details|Form|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogsCredentialDetailsForm';
export type SPCatalogsCredentialDetailsFormLocNames =
	| `${LocNameStart}NotificationChangesSaved`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}ErrorNameRequired`
	| `${LocNameStart}LabelNameAbbr`
	| `${LocNameStart}LabelGroupName`
	| `${LocNameStart}LabelTranscriptEnabled`
	| `${LocNameStart}LabelDisplayOrder`
	| `${LocNameStart}ErrorDisplayOrderNumbers`
	| `${LocNameStart}LabelUrl`
	| `${LocNameStart}ErrorUrlInvalid`
	| `${LocNameStart}LabelDescription`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonUpdate`;

export const spCatalogsCredentialDetailsFormLocs: LocDefs<SPCatalogsCredentialDetailsFormLocNames> =
	{
		SPCatalogsCredentialDetailsFormNotificationChangesSaved: {
			defaultValue: 'Changes saved',
			description: 'Changes saved notification',
			displayPath: `${pathStart}Changes saved`,
			displayType: 'Notification',
			legacyName: 'Credential/CatalogsCredential.Details.NotificationMessage.ChangesSaved',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormLabelName: {
			defaultValue: 'Name',
			description: 'Label for: Name.',
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			legacyName: 'Credential/CatalogsCredential.Details.FieldLabel.Name',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormErrorNameRequired: {
			defaultValue: 'Name is required',
			description: 'Error saying that the name is required.',
			displayPath: `${pathStart}Name Required`,
			displayType: 'Error',
			legacyName: 'Credential/CatalogsCredential.Details.FieldError.NameRequired',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormLabelNameAbbr: {
			defaultValue: 'Name Abbreviation',
			description: 'Label for: Name Abbreviation.',
			displayPath: `${pathStart}Name Abbreviation`,
			displayType: 'Label',
			legacyName: 'Credential/CatalogsCredential.Details.FieldLabel.NameAbbr',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormLabelGroupName: {
			defaultValue: 'Group Name',
			description: 'Label for: Group Name.',
			displayPath: `${pathStart}Group Name`,
			displayType: 'Label',
			legacyName: 'Credential/CatalogsCredential.Details.FieldLabel.GroupName',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormLabelTranscriptEnabled: {
			defaultValue: 'Transcript Enabled',
			description: 'Label for: Transcript Enabled.',
			displayPath: `${pathStart}Transcript Enabled`,
			displayType: 'Label',
			legacyName: 'Credential/CatalogsCredential.Details.FieldLabel.TranscriptEnabled',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormLabelDisplayOrder: {
			defaultValue: 'Display Order',
			description: 'Label for: Display Order.',
			displayPath: `${pathStart}Display Order`,
			displayType: 'Label',
			legacyName: 'Credential/CatalogsCredential.Details.FieldLabel.DisplayOrder',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormErrorDisplayOrderNumbers: {
			defaultValue: 'Display order must only contain numbers',
			description: 'Error saying that the display order must only contain numbers.',
			displayPath: `${pathStart}Display Order Numbers`,
			displayType: 'Error',
			legacyName: 'Credential/CatalogsCredential.Details.FieldError.DisplayOrderNumbers',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormLabelUrl: {
			defaultValue: 'URL',
			description: 'Label for: URL.',
			displayPath: `${pathStart}URL`,
			displayType: 'Label',
			legacyName: 'Credential/CatalogsCredential.Details.FieldLabel.Url',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormErrorUrlInvalid: {
			defaultValue: 'Please enter a valid URL, such as https://example.com',
			description: 'Error saying to enter a valid URL.',
			displayPath: `${pathStart}URL invalid`,
			displayType: 'Error',
			legacyName: 'Credential/CatalogsCredential.Details.FieldError.UrlInvalid',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormLabelDescription: {
			defaultValue: 'Description',
			description: 'Label for: Description.',
			displayPath: `${pathStart}Description`,
			displayType: 'Label',
			legacyName: 'Credential/CatalogsCredential.Details.FieldLabel.Description',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button text',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			legacyName: 'Credential/CatalogsCredential.Details.Button.Cancel',
			...sharedProperties,
		},
		SPCatalogsCredentialDetailsFormButtonUpdate: {
			defaultValue: 'Update',
			description: 'Update button text',
			displayPath: `${pathStart}Update`,
			displayType: 'Button',
			legacyName: 'Credential/CatalogsCredential.Details.Button.Update',
			...sharedProperties,
		},
	};

export type SPCatalogsCredentialDetailsFormLocType =
	LocMap<SPCatalogsCredentialDetailsFormLocNames>;
